export default "__VITE_ASSET__d40081b7__"